<template>
  <b-container>
    <b-card class="mb-4">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <span>Mis Datos</span>
        </div>
      </template>

      <b-overlay :show="show" rounded="sm">
        <b-form @submit.prevent="updateProvider">
          <!-- Subtítulo: Información básica -->
          <h5 class="text-left text-primary mb-3">Información básica</h5>
          <b-row>
            <!-- CUIT -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="CUIT" label-for="cuit" class="label">
                <b-form-input
                  id="cuit"
                  v-model="editForm.cuit"
                  size="sm"
                  placeholder="Ejemplo: 20304050601"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Razón Social -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Razón Social"
                label-for="companyName"
                class="label"
              >
                <b-form-input
                  id="companyName"
                  v-model="editForm.company_name"
                  size="sm"
                  placeholder="Nombre de la empresa"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Domicilio Fiscal -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Domicilio Fiscal"
                label-for="taxDomicile"
                class="label"
              >
                <b-form-input
                  id="taxDomicile"
                  v-model="editForm.tax_domicile"
                  size="sm"
                  placeholder="Dirección fiscal"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Código Postal -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Código Postal"
                label-for="postalCode"
                class="label"
              >
                <b-form-input
                  id="postalCode"
                  v-model="editForm.postal_code"
                  size="sm"
                  placeholder="Ejemplo: 1234"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Provincia -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group
                label="Provincia"
                label-for="province"
                class="label"
              >
                <b-form-input
                  id="province"
                  v-model="editForm.province.name"
                  size="sm"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Ciudad -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Ciudad" label-for="city" class="label">
                <b-form-input
                  id="city"
                  v-model="editForm.location.name"
                  size="sm"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- CBU -->
            <b-col cols="12" md="12" class="mb-3">
              <b-form-group label="CBU" label-for="cbu" class="label">
                <b-form-input
                  id="cbu"
                  v-model="editForm.cbu"
                  size="sm"
                  placeholder="Ejemplo: 0123456789012345678901"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Email -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Email" label-for="email" class="label">
                <b-form-input
                  id="email"
                  type="email"
                  v-model="editForm.email"
                  size="sm"
                  placeholder="correo@ejemplo.com"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- Teléfono -->
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Teléfono" label-for="phone" class="label">
                <b-form-input
                  id="phone"
                  v-model="editForm.phone"
                  size="sm"
                  placeholder="Ejemplo: +5491145678901"
                  disabled
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <!-- Subtítulo: Archivos -->
          <h5 class="text-left text-primary mt-4">Archivos</h5>
          <br />
          <!-- Archivos IVA -->
          <b-col cols="12" class="mb-4">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Condición frente a IVA" class="label">
                  <b-form-radio-group
                    disabled
                    v-model="editForm.vat_condition"
                    :options="ivaOptions"
                    name="inscriptionIva"
                    stacked
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-row>
                  <template v-for="file in editForm.files">
                    <b-col v-if="file.type === 'iva'" :key="file.id" cols="3">
                      <div
                        class="d-flex justify-content-between position-relative"
                      >
                        <div
                          style="width: 100px; height: 100px; overflow: hidden"
                        >
                          <img
                            v-if="isImage(file.path)"
                            :src="`${url}/${file.path.replace(
                              'public',
                              'storage'
                            )}`"
                            alt="file-preview"
                            class="img-thumbnail"
                            @click="openFile(file)"
                            style="
                              width: 100%;
                              height: 100%;
                              object-fit: cover;
                              cursor: pointer;
                            "
                          />
                          <div
                            v-else
                            class="img-thumbnail d-flex justify-content-center align-items-center"
                            @click="openFile(file)"
                            style="
                              width: 100%;
                              height: 100%;
                              background-color: #f0f0f0;
                              cursor: pointer;
                            "
                          >
                            <span class="text-center">PDF</span>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <hr />

          <!-- Archivos IIBB -->
          <b-col cols="12" class="mb-4">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Inscripción en IIBB" class="label">
                  <b-form-radio-group
                    v-model="editForm.iibb_registration"
                    :options="iibbOptions"
                    name="inscriptionIibb"
                    stacked
                    disabled
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-row>
                  <template v-for="file in editForm.files">
                    <b-col v-if="file.type === 'iibb'" :key="file.id" cols="3">
                      <div
                        class="d-flex justify-content-between position-relative"
                      >
                        <div
                          style="width: 100px; height: 100px; overflow: hidden"
                        >
                          <img
                            v-if="isImage(file.path)"
                            :src="`${url}/${file.path.replace(
                              'public',
                              'storage'
                            )}`"
                            alt="file-preview"
                            class="img-thumbnail"
                            @click="openFile(file)"
                            style="
                              width: 100%;
                              height: 100%;
                              object-fit: cover;
                              cursor: pointer;
                            "
                          />
                          <div
                            v-else
                            class="img-thumbnail d-flex justify-content-center align-items-center"
                            @click="openFile(file)"
                            style="
                              width: 100%;
                              height: 100%;
                              background-color: #f0f0f0;
                              cursor: pointer;
                            "
                          >
                            <span class="text-center">PDF</span>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <hr />
          <b-col cols="12">
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Posee exenciones o exclusiones"
                  class="label"
                >
                  <b-form-radio-group
                    disabled
                    v-model="editForm.exemption"
                    :options="exemptionOptions"
                    name="exemption"
                    stacked
                  ></b-form-radio-group>
                  <small
                    v-if="touched.exemption && !form.exemption"
                    class="text-danger"
                    >Debe seleccionar una opción</small
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-row>
                  <template v-for="file in editForm.files">
                    <b-col v-if="file.type == 'exemp'" :key="file.id" cols="3">
                      <div class="d-flex justify-content-between">
                        <!-- Vista previa del archivo -->
                        <div
                          style="width: 100px; height: 100px; overflow: hidden"
                        >
                          <img
                            v-if="isImage(file.path)"
                            :src="`${url}/${file.path.replace(
                              'public',
                              'storage'
                            )}`"
                            alt="file-preview"
                            class="img-thumbnail"
                            @click="openFile(file)"
                            style="
                              width: 100%;
                              height: 100%;
                              object-fit: cover;
                              cursor: pointer;
                            "
                          />
                          <div
                            v-else
                            class="img-thumbnail d-flex justify-content-center align-items-center"
                            @click="openFile(file)"
                            style="
                              width: 100%;
                              height: 100%;
                              background-color: #f0f0f0;
                              cursor: pointer;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                          >
                            <span class="text-center">PDF</span>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </template>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-form>
      </b-overlay>
    </b-card>
  </b-container>
</template>
<script>
import axios from "../../utils/axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      editForm: {
        province: { name: null },
        location: { name: null },
      },
      status: "idle", // idle, loading, success
      selectedFile: null,
      showModal: false,
      show: false,
      /*editForm: {
        province: {
          id: 0,
        },
        location: {
          id: 0,
        },
      },*/
      provinces: [],
      cities: [],
      citiesFromProvince: [],
      selectedItem: {
        province: { name: null },
        location: { name: null },
      },
      ivaOptions: [
        { value: "ri", text: "RI (Responsable Inscripto)" },
        { value: "mt", text: "Monotributo" },
        { value: "ex", text: "Exento" },
      ],
      iibbOptions: [
        { value: "lo", text: "Local" },
        { value: "cm", text: "Convenio Multilateral" },
        { value: "nri", text: "No registra inscripción" },
      ],
      exemptionOptions: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
      touched: {
        cuit: false,
        companyName: false,
        taxDomicile: false,
        postalCode: false,
        province: false,
        city: false,
        cbu: false,
        email: false,
        phone: false,
        inscriptionIva: false,
      },
      files: {
        iva: null,
        iibb: null,
        exemption: [],
      },
      selectedFile: null,
      url: "https://api.rup.antonioluquin.com.ar/",
      msjModal: "",
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    this.getProvider();
  },
  methods: {
    getProvider() {
      this.msgLoading = "Cargando...";
      this.show = true;
      axios
        .get("/providers/getProvider", {
          params: {
            user_id: this.user.id,
          },
        })
        .then((response) => {
          this.editForm = response.data;
          this.show = false;
        })
        .catch((error) => {
          console.error("Error al obtener los datos del Proveedor:", error);
          this.show = false;
        });
    },
    saveChanges() {
      // Aquí puedes hacer una petición API para guardar los cambios
      this.showEditModal = false;
    },
    formatKey(key) {
      const labels = {
        cuit: "CUIT",
        companyName: "Razón Social",
        taxDomicile: "Domicilio Fiscal",
        postalCode: "Código Postal",
        cbu: "CBU",
        email: "Email",
        phone: "Teléfono",
        province: "Provincia",
        city: "Ciudad",
        inscriptionIva: "Inscripción IVA",
        inscriptionIibb: "Inscripción IIBB",
        exemption: "Exención",
      };
      return labels[key] || key;
    },
    getFileUrl(path) {
      return `${this.url}/${path.replace("public", "storage")}`;
    },
    isImage(path) {
      return /\.(jpeg|jpg|gif|png)$/i.test(path);
    },
    isPdf(path) {
      return /\.pdf$/i.test(path);
    },
    openFile(file) {
      window.open(`${this.url}/${this.getStoragePath(file.path)}`, "_blank");
    },
    getStoragePath(path) {
      return path.replace("public", "storage");
    },
    deleteFile(fileId) {
      this.show = true;
      this.$bvModal.hide("modal-delete-file");
      axios
        .delete("/providers/deleteFile", {
          params: {
            fileId: fileId,
          },
        })
        .then((response) => {
          this.editForm.files = this.editForm.files.filter(
            (file) => file.id !== fileId
          );
          this.show = false;
          this.msjModal = response.data;
          this.$bvModal.show("success-modal");
        })
        .catch((error) => {
          console.error(error);
          this.show = false;
        });
    },
    triggerFileInput(inputRef) {
      this.$refs[inputRef].click();
    },
    addFile(type, event) {
      const file = event.target.files[0];
      if (file) {
        this.show = true;
        let formData = new FormData();
        formData.append("typeFile", type);
        formData.append("provider_id", this.editForm.id);
        formData.append("file", file);

        axios
          .post("/providers/saveFile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            //agregamos el archivo al array de archivos
            this.editForm.files.push(response.data);
            this.show = false;
            this.msjModal = "Archivo guardado con éxito";
            this.$bvModal.show("success-modal");
          })
          .catch((error) => {
            console.error(error);
            this.show = false;
          });
      }
    },
    updateProvider() {
      if (this.status === "loading") return;
      this.status = "loading";
      this.show = true;
      axios
        .put("/providers/update", this.editForm)
        .then((response) => {
          /*// Buscar el índice del proveedor en items y actualizarlo
          const index = this.items.findIndex(
            (item) => item.id === this.editForm.id
          );
          if (index !== -1) {
            this.$set(this.items, index, this.editForm);
          }*/
          this.status = "success";
          this.show = false;
          setTimeout(() => {
            this.status = "idle";
          }, 2000);
        })
        .catch((error) => {
          console.error("Error al actualizar proveedor:", error);
          this.status = "idle";
          this.show = false;
        });
    },
    openModalDialogConfirmation(file) {
      this.$bvModal.show("modal-delete-file");
      this.selectedFile = file;
    },
    goToList() {
      this.$router.push({ name: "providers/list" });
    },
  },
};
</script>
<style scoped>
.square-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px; /* Bordes cuadrados */
  font-size: 20px;
}
.label {
  font-size: 9pt !important;
  text-align: left;
  margin-bottom: 1pt !important;
}
</style>
  